import { usePublicApi } from "api/setup";
import { ApiError, PagedResponse } from "api/shared";
import formatUrl from "utils/formatUrl";

import api from "config/urls/api";

type GetHistoricalSynchronizationParams = {
  companyId: string;
  orderBy?: string;
  page: number;
  pageSize: number;
  query?: string;
};

export interface HistoricalSynchronizationResponse {
  companyId: string;
  completed: Date;
  connectionId: string;
  dataType: string;
  id: string;
  isCompleted: boolean;
  isErrored: boolean;
  progress: number;
  requested: Date;
  status: string;
}

export const useGetHistoricalSynchronizationsQuery = (
  { companyId, ...queryParams }: GetHistoricalSynchronizationParams,
  manual = false
) => {
  return usePublicApi<
    PagedResponse<HistoricalSynchronizationResponse>,
    ApiError
  >(
    {
      url: formatUrl(api.companies.history, { companyId }),
      params: { ...queryParams },
    },
    { manual }
  );
};

export const useActiveSynchronizationQuery = (
  companyId: string,
  manual = false
) => {
  const activeStatuses = [
    "Queued",
    "Initial",
    "Fetching",
    "MapQueued",
    "Mapping",
    "ProcessingQueued",
    "Routing",
    "Processing",
    "ValidationQueued",
    "Validating",
  ];
  const query = `status=${activeStatuses.join("||status=")}`;
  return useGetHistoricalSynchronizationsQuery(
    { companyId, pageSize: 1, page: 1, query },
    manual
  );
};

export const useLatestSynchronizationQuery = (
  companyId: string,
  manual = false
) => {
  return useGetHistoricalSynchronizationsQuery(
    { companyId, pageSize: 1, page: 1 },
    manual
  );
};
